import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { SocialCoachSession, UpdateMeParams } from "@/services/bedrock/dtos";

const SESSION_SERVICE = `${Constants.API_URL}/bedrock/me`;

export class SessionServices {
  @scCatchServiceException()
  static async getMe(skipAuthRedirect?: boolean): Promise<SocialCoachSession> {
    const { data } = await axios.get<SocialCoachSession>(SESSION_SERVICE, {
      ...({ skipAuthRedirect } as any),
    });
    return data;
  }

  @scCatchServiceException()
  static async updateMe(params: UpdateMeParams): Promise<SocialCoachSession> {
    // Note: If updating 'email', the request must be accompanied by an active,
    // stepped-up MFA session (which the BFF handles automatically via cookies).
    const { data } = await axios.patch<SocialCoachSession>(SESSION_SERVICE, params);
    return data;
  }
}
